module.exports = __webpack_public_path__ + "img/error.a2ed3ab1.png";